/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
    Input,
    Label,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
} from "reactstrap";
import Select from "react-select";
const TSSelectMultiple = props => {
    const [value, setValue] = useState((props.value != null) ? props.value : []);
    const [label, setLabel] = useState((props.label != null) ? props.label : '');
    const [type, setType] = useState((props.type != null) ? props.type : 'select');
    const [placeholder, setPlaceholder] = useState((props.placeholder != null) ? props.placeholder : '');
    const [icon, setIcon] = useState('');

    const [options, setOptions] = useState((props.options !== "undefined") ? props.options : []);
    const [styles, setStyles] = useState((props.styles !== "undefined") ? props.styles : null);
    const [isRequire, setIsRequire] = useState(props.isRequire);
    const [isDisabled, setIsDisabled] = useState(props.isDisabled);
    const [zIndex, setzIndex] = useState((props.zIndex != null) ? props.zIndex : 'null');
    const [defaultValue, setDefaultValue] = useState([]/*{ label: null, value: null }*/);

  useEffect(() => {

      if (props.options != null) {
          setValue(props.value);
      }

  }, [props.value]);

  function handleChange(e) {
    var val = (e != null ) ? e.value : null;
    if (props.onChange) {
      props.onChange(e);
      setValue(val);
    }
  }

  const customStyles = {
    container: (base) => ({ ...base, zIndex: zIndex }),
    control: (base) => ({ ...base, /*padding: '12px 5px',*/ marginBottom: '10px', border: (false? "red solid 1px" : "") }),
    menu: (base) => ({ ...base,zIndex: 2, textAlign: 'left', fontSize: '1.2em' }),
    singleValue: (base) => ({ ...base, fontSize: '1.2em' }),
}
  return (
    
    <div>
          {(label != "") ? <Label for="">{label}</Label>:<></>}
              <Select
              isMulti
              className="basic-multi-select"
              styles={customStyles}
              options={props.options}
              onChange={handleChange}
              defaultValue={defaultValue}
              isDisabled={isDisabled}
              value={value}
              />


    </div>
  );
};

export default TSSelectMultiple;
